import React, { useMemo, useState } from 'react';
import CardWorldMap from './viewComponents/card_worldmap';
import CardStats from './viewComponents/card_stats';
import CardDynamicTable from './viewComponents/card_dynamic_table';
import { calculateTravelStats } from '../moduleServices/trips_stats';

const TabTravelOverview = ({ trips, isTripsLoading }) => {
  const [viewMode, setViewMode] = useState('region'); // 'region' | 'year'

  // ##### Calculate travel statistics
  const travelStats = useMemo(() => {
    return calculateTravelStats(trips);
  }, [trips]);

  return (
    <div className="p-2 space-y-2">
      {/* Main Content Area */}
      <div className="flex flex-col lg:flex-row items-stretch justify-center gap-2 w-full">
        {/* World Map */}
        <div className="w-full max-w-full lg:max-w-[650px] bg-white rounded-xl shadow p-2">
          <CardWorldMap 
            trips={trips}
            isTripsLoading={isTripsLoading}
          />
        </div>

        {/* Stats Cards */}
        <div className="w-full lg:w-72 flex">
          <CardStats 
            travelStats={travelStats}
            isTripsLoading={isTripsLoading}
          />
        </div>
      </div>

      {/* Travel Dynamic Table */}
      <div className="bg-white p-2 rounded-xl shadow">
        {/* Header and Segmented Button */}
        <div className="flex items-center justify-between mb-2 px-2">
          <h3 className="text-base font-semibold text-gray-700">Trips Overview</h3>
          <div className="bg-gray-200 rounded-full p-0.5 flex">
            {['region', 'year'].map((mode, index) => (
              <button
                key={mode}
                onClick={() => setViewMode(mode)}
                className={`
                  px-3 py-1 text-xs font-medium transition-all
                  ${index === 0 ? 'rounded-l-full' : 'rounded-r-full'}
                  ${viewMode === mode
                    ? 'text-white bg-gray-700'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
                  }
                `}
              >
                By {mode === 'region' ? 'Region' : 'Year'}
              </button>
            ))}
          </div>
        </div>

        <CardDynamicTable 
          trips={trips}
          isTripsLoading={isTripsLoading}
          viewMode={viewMode}
        />
      </div>
    </div>
  );
};

export default TabTravelOverview;